import { atom } from 'recoil';

export const initialWizardStateAtom = atom<{
  isNewTemplate: boolean;
  isSet: boolean;
}>({
  key: 'initialWizardStateAtom',
  default: {
    isNewTemplate: false,
    isSet: false,
  },
});
